import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { DateDisplay, ProfileDisplay } from "../../../components";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { useAuth } from "react-oidc-context";
import _ from "lodash";

import styled from "styled-components";
import { NumericFormat } from "react-number-format";

const CustodianCashBalancesTableRowColumn = styled.td`
    padding: 0.6rem !important;
    vertical-align: middle;
    width: ${({ width }) => width}%;
`;

const CustodianCashBalanceManagementTableRow = ({ data, index, style }) => {
    const { height } = style;
    const openMasterAccount = useOpenMasterAccount();

    const {
        user: { profile },
    } = useAuth();

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= data.length) {
        return <TableLoadingRow />;
    }

    const {
        platformAccountId,
        days,
        cashBalance,
        latestBalanceDate,
        designation,
        masterAccountStatus,
        masterAccountName,
        masterAccountId,
        masterAccountReference,
        adviser,
        adviserId
    } = data[index];

    const handleOpenMasterAccount = (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }
        openMasterAccount(masterAccountId);
    };

    return (
        <tr style={{ height }}>
            <CustodianCashBalancesTableRowColumn width={35}>
                {masterAccountId != null &&
                <a href={`/client/${masterAccountId}`} className="text-truncate" onClick={handleOpenMasterAccount}>
                    <span>
                        {masterAccountReference} - {masterAccountName}
                    </span>
                </a>}
                {masterAccountId == null && 
                    <span>
                        Unmapped
                    </span>
                }
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={17.5}>
                {adviserId ? (<ProfileDisplay userId={adviserId} />) : (<span>-</span>)}
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={17.5}>
                <span>{designation}</span>
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={7.5}>
                <span>{platformAccountId}</span>
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={7.5}>
                 <NumericFormat
                    value={cashBalance}
                    thousandSeparator={true}
                    decimalScale={2}
                    displayType="text"
                    prefix={"£"}
                />
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={7.5}>
                <span><DateDisplay>{latestBalanceDate}</DateDisplay></span>
            </CustodianCashBalancesTableRowColumn>
            <CustodianCashBalancesTableRowColumn width={7.5}>
                <span>{getNumberOfDays(days)}</span>
            </CustodianCashBalancesTableRowColumn>
                      
            {/* Action */}
            {/* <ReviewManagementDetailTableRowActionColumn review={data[index]} /> */}
        </tr>
    );
};


const getNumberOfDays = (days) => {
        if (days <= 31) return days.toFixed(0) + " days";

        if (days > 31 && days < 365)
            return Math.round(days/30.44).toFixed(0) + " months";

        return (days / 365).toFixed(1) + " years";
};

export default CustodianCashBalanceManagementTableRow;
